<template>
  <div class="mt-2 flex min-h-0 grow flex-col">
    <WarningDisable permission="key_logger" />
    <div class="flex min-h-0 grow flex-col gap-6">      <form
        ref="status_form"
        class="mb-4 flex flex-wrap items-end gap-2"
        @submit="submit_without_reloading"
        @reset="keyword = undefined"
      >
        <label class="input w-full md:w-fit 2xl:w-fit">
          <i class="fa-solid fa-magnifying-glass text-base-content/80"></i>
          <input
            type="text"
            placeholder="Tìm kiếm theo từ khóa"
            name="keyword"
            v-model="keyword"
          />
        </label>
        <input
          class="btn btn-outline"
          type="reset"
          value="&#8635; Đặt lại"
          :disabled="keylogger_store.loading.get_keyloggers"
        />
        <button
          class="btn btn-primary btn-outline"
          type="submit"
          :disabled="
            !filter_has_changed || keylogger_store.loading.get_keyloggers
          "
        >
          &#10003; Áp dụng
        </button>
      </form>

      <div ref="container" class="grid min-h-0 grow grid-rows-[auto_1fr]">
        <div class="text-base-content/80 mb-2 text-xl font-bold">
          Lịch sử ghi phím
        </div>
        <div
          ref="keylogger_content"
          class="bg-base-100 flex min-h-0 flex-col overflow-auto p-2 transition-none"
        >
          <Loading v-if="keylogger_store.loading.get_keyloggers" />
          <NotFound
            v-else-if="
              !keylogger_store.keyloggers ||
              keylogger_store.keyloggers.length === 0
            "
          />
          <div
            v-for="(action, _idx) in keylogger_store.keyloggers"
            :key="action.id"
            class="chat chat-start"
          >
            <div class="max-w-full">
              <div class="chat-bubble">
                <KeylogEvents :events="parseEvents(action.data)" />
              </div>
              <div class="text-base-content/50 mt-1 text-[11px] font-medium">
                {{ formatDateTime(action.created) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { str_from_query } from "@/api";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import { router } from "@/router/router";
import { useInfiniteScroll } from "@vueuse/core";
import { computed, ref } from "vue";
import WarningDisable from "../WarningDisable.vue";
import { use_keylogger } from "./useKeylogger";
import KeylogEvents from "./KeylogEvents.vue";
import { parseKeylogData, type KeylogEvent } from "./parseKeylog";

const init_keyword = computed(() => str_from_query("keyword"));

const keyword = ref<string | undefined>(init_keyword.value);
const filter_has_changed = computed(() => keyword.value !== init_keyword.value);
const keylogger_store = use_keylogger();
const parseEvents = (data?: string): KeylogEvent[] => parseKeylogData(data);
/** Full timestamp including day, e.g. "2026-09-18 14:07". */
const formatDateTime = (ts?: number) => {
  if (!ts) return "";
  const d = new Date(ts);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(
    d.getDate(),
  )} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
const keylogger_content = ref<HTMLDivElement | null>();
useInfiniteScroll(
  keylogger_content,
  async () => {
    // Must await: vueuse re-checks and re-fires the moment this promise
    // settles, so a fire-and-forget call double-fires every page.
    await keylogger_store.get_keyloggers();
  },
  {
    distance: 10,
    canLoadMore: () => keylogger_store.can_load_more,
    direction: "bottom",
  },
);

const submit_without_reloading = (e: Event) => {
  e.preventDefault();
  router.push({
    name: router.currentRoute.value.name,
    query: {
      ...router.currentRoute.value.query,
      page: 1,
      keyword: keyword.value,
    },
  });
};
</script>
